// Max flow-control workflow emails per recipient address per UTC day. Enforced in
// the API limiter and referenced in user-facing copy, so both must share this value.
export const FLOW_CONTROL_EMAIL_DAILY_LIMIT = 50;
